import { heroStats } from '@/mocks/content';

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="top" className="relative w-full h-[560px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20warm%20painterly%20illustration%20of%20a%20cozy%20reading%20corner%20with%20a%20tall%20stack%20of%20vintage%20hardcover%20books%2C%20a%20soft%20linen%20armchair%20beside%20a%20sunlit%20window%2C%20autumn%20amber%20terracotta%20and%20deep%20olive%20green%20tones%2C%20textured%20abstract%20brush%20strokes%2C%20calm%20literary%20atmosphere%2C%20editorial%20art%20style%2C%20soft%20space%20in%20the%20center%2C%20no%20text&width=1600&height=900&seq=pretty-nanny-hero&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-8">
        <span className="animate-fade-in inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 text-background-100 text-xs md:text-sm backdrop-blur-sm">
          <i className="ri-book-2-line" />
          小说 · 漫画 · 无删减 TXT 阅读资源
        </span>

        <h1 className="animate-fade-up mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-4xl">
          漂亮的保姆 · 无删减阅读资源导航
        </h1>

        <p className="animate-fade-up mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-200">
          本站整理《漂亮的保姆》小说与漫画的无删减 TXT 资源信息，涵盖作品速览、故事背景、人物类型、
          资源格式与阅读脉络，帮助你在开始阅读前快速定位所需内容。
        </p>

        <div className="animate-fade-up mt-8 flex flex-col sm:flex-row items-center gap-3">
          <button
            type="button"
            onClick={() => scrollTo('resources')}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-folder-download-line" />
            浏览阅读资源
          </button>
          <button
            type="button"
            onClick={() => scrollTo('overview')}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-100 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
          >
            <i className="ri-eye-line" />
            查看作品速览
          </button>
        </div>

        <div className="animate-fade-up mt-10 w-full max-w-3xl grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-50/20 bg-background-50/10 backdrop-blur-sm px-3 py-3 md:py-4 flex flex-col items-center gap-1"
            >
              <i className={`${stat.icon} text-lg text-primary-300`} />
              <span className="font-heading text-base md:text-lg font-bold text-background-50">{stat.value}</span>
              <span className="text-xs text-background-300">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}